import { LeaderBoard } from '~/components/highscores/leaderboard';
import { Game } from '~/types/game';

import styles from './RightSide.module.css';

export type RightSideProps = {
    clientID: string;
    game: Game;
};

export function RightSide({ clientID, game }: RightSideProps) {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img className={styles.gameLogo} src={game.logo} alt={game.name} />
            </div>
            <div className={styles.ranking}>
                {/* <h3 className={styles.rankTitle}>{game.name} Rank</h3> */}
                <LeaderBoard clientID={clientID} game={game} />
            </div>
        </div>
    );
}
